import React, { useState } from "react";
import {
  Loading,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Box,
  FormControl,
} from "../../components";
import {
  history,
  LoginService,
  SessionService,
  ConfiguracoesService,
  // UsuariosLocalService,
  // SincService,
  notification,
} from "../../services";
import { value, InputErros } from "../../helpers";
import { responseErros } from "../../utils";
import { loginValidator } from "./middlewares";
import ReCAPTCHA from "react-google-recaptcha";
import store from "../../config/store";
import { RecuperarSenhaDialogo, DialogoFiliais } from "./components";
// import CryptoJS from "crypto-js";
import { InputLabel } from "@mui/material";
import { float3D, sxInputLogin } from "./constantes.login";
import palette from "../../styles/light-theme/palette";
import "./login-style.scss";

const loginService = new LoginService();
const sessionService = new SessionService();
const configuracoesService = new ConfiguracoesService();
// const sincService = new SincService();

const floatingIcons = [
  {
    iconClass: "ph-fill ph-printer",
    top: "8%",
    right: "4%",
    size: "40px",
    delay: "0s",
    duration: "6s",
  },
  {
    iconClass: "ph-fill ph-archive",
    top: "30%",
    right: "12%",
    size: "36px",
    delay: "0.3s",
    duration: "9s",
  },
  {
    iconClass: "ph-fill ph-coins",
    top: "16%",
    left: "10%",
    size: "42px",
    delay: "0.8s",
    duration: "6.5s",
  },
  {
    iconClass: "ph-bold ph-basket",
    top: "35%",
    left: "26%",
    size: "42px",
    delay: "0.8s",
    duration: "3s",
  },
  {
    iconClass: "ph-fill ph-storefront",
    bottom: "10%",
    left: "15%",
    size: "42px",
    delay: "0.8s",
    duration: "2s",
  },
  {
    iconClass: "ph-bold ph-credit-card",
    top: "12%",
    right: "22%",
    size: "44px",
    delay: "0.5s",
    duration: "7s",
  },
  {
    iconClass: "ph-fill ph-cash-register",
    top: "55%",
    right: "8%",
    size: "46px",
    delay: "1s",
    duration: "8s",
  },
  {
    iconClass: "ph-bold ph-receipt",
    top: "70%",
    right: "15%",
    size: "40px",
    delay: "0.4s",
    duration: "7.5s",
  },
  {
    iconClass: "ph-fill ph-shopping-cart",
    top: "18%",
    left: "38%",
    size: "44px",
    delay: "0.9s",
    duration: "6.5s",
  },
  {
    iconClass: "ph-bold ph-barcode",
    top: "48%",
    left: "5%",
    size: "42px",
    delay: "1.2s",
    duration: "9s",
  },
  {
    iconClass: "ph-fill ph-package",
    bottom: "50%",
    right: "20%",
    size: "44px",
    delay: "0.6s",
    duration: "7s",
  },
  {
    iconClass: "ph-bold ph-tag",
    bottom: "35%",
    left: "30%",
    size: "38px",
    delay: "1.1s",
    duration: "8s",
  },
  {
    iconClass: "ph-fill ph-bank",
    top: "5%",
    left: "45%",
    size: "40px",
    delay: "0.7s",
    duration: "9s",
  },
  {
    iconClass: "ph-bold ph-device-mobile",
    bottom: "5%",
    right: "35%",
    size: "38px",
    delay: "1.3s",
    duration: "7s",
  },
  {
    iconClass: "ph-bold ph-trend-up",
    bottom: "15%",
    left: "50%",
    size: "44px",
    delay: "0.9s",
    duration: "8.5s",
  },
];

const FloatingBackground = () => (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      overflow: "hidden",
      zIndex: 0,
      pointerEvents: "none",
    }}
  >
    {floatingIcons.map((item, index) => (
      <Box
        className="float-icons"
        key={index}
        sx={{
          position: "absolute",
          top: item.top,
          left: item.left,
          right: item.right,
          bottom: item.bottom,
          opacity: 0.1,
          color: "white",
          transformStyle: "preserve-3d",
          animation: `${float3D} ${item.duration} ease-in-out infinite`,
          animationDelay: item.delay,
          fontSize: item.size,
        }}
      >
        <i className={item.iconClass}></i>
      </Box>
    ))}
  </Box>
);

const LoginView = () => {
  const [login, setLogin] = useState({});
  const [loading, setLoading] = useState(false);
  const [inputErro, setInputErro] = useState([]);
  const [tempoBloqueio, setTempoBloqueio] = useState("5:00");
  const [usuarioBloqueado, setUsuarioBloqueado] = useState(false);
  // const [dadosOffline, setDadosOffline] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [tokenRecaptcha, setTokenRecaptcha] = useState(null);
  const [erro, setErro] = useState(false);
  const [abrirDialogoRecuperarSenha, setAbrirDialogoRecuperarSenha] =
    useState(false);
  const [dados, setDados] = useState(false);
  const [abrirDialogoFiliais, setAbrirDialogoFiliais] = useState(false);
  const recaptchaRef = React.createRef();
  const inputErros = new InputErros(inputErro, setInputErro);
  const logoHorizontal =
    "https://public.siafevolution.com.br/logo-lite-horizontal.svg";

  const onSubmitLogar = (event) => {
    event.preventDefault();
    setErro(false);
    loginValidator
      .validate(login, { abortEarly: false })
      .then(() => {
        // if (pdvOnLine) {
        loginOnline();
        // } else {
        //   loginOffline();
        // }
      })
      .catch((err) => inputErros.set(err));
  };

  // async function loginOffline() {
  //   const dadosUsuarioEncrypted = await buscarDadosUsuarioOffline(login.email);
  //   if (!dadosUsuarioEncrypted) {
  //     return notification.alertaGenericos("Modo offline não disponível");
  //   }
  //   const dadosUsuario = decrypt(
  //     login.senha,
  //     login.email,
  //     dadosUsuarioEncrypted,
  //   );
  //   if (dadosUsuario) {
  //     processarDadosUsuario({
  //       token: "offline-token",
  //       dados: dadosUsuario,
  //     });
  //   } else {
  //     notification.alertaGenericos("E-mail ou senha inválido");
  //   }
  // }

  // async function buscarDadosUsuarioOffline(email) {
  //   return await UsuariosLocalService.getByEmail(email);
  // }

  // function decrypt(password, email, encrypted) {
  //   try {
  //     const keyIv = CryptoJS.PBKDF2(password, email, {
  //       keySize: 48 / 4,
  //       iterations: 1000,
  //       hasher: CryptoJS.algo.SHA256,
  //     });
  //     const key = CryptoJS.lib.WordArray.create(keyIv.words.slice(0, 8));
  //     const iv = CryptoJS.lib.WordArray.create(keyIv.words.slice(8, 12));
  //     const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
  //       iv: iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7,
  //     });
  //     const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  //     if (!decryptedText || decryptedText.length === 0) {
  //       return null;
  //     }
  //     return JSON.parse(decryptedText);
  //   } catch (error) {
  //     console.error("Erro na descriptografia:", error);
  //     return null;
  //   }
  // }

  async function processarDadosUsuario(dados) {
    sessionService.setSession(dados);
    if (
      dados.diasVencimento &&
      dados.diasVencimento > 0 &&
      dados.diasVencimento <= 10
    ) {
      notification.confirmacaoGenericos({
        icon: "warning",
        title: "Atenção",
        text: `Sua licença irá expirar em ${dados.diasVencimento} dia${
          dados.diasVencimento > 1 ? "s" : ""
        }. Consulte o suporte para a regularização.`,
        confirmButtonText: "OK",
      });
    }
    // await sincronizacaoOfflineInicial(dados);
    if (dados.dados.usuario?.acessosEmpresas?.length > 1) {
      setDados(dados.dados);
      setAbrirDialogoFiliais(true);
    } else {
      await buscarConfiguracoesEmpresa();
      history.push("/dashboard");
    }
  }

  // async function sincronizacaoOfflineInicial(dados) {
  //   if (dados?.dados?.empresa?.modoOfflinePdv && !dadosOffline) {
  //     sessionService.setSincronizacaoInicial(true);
  //     await sincService.sincronizar();
  //   }
  // }

  const loginOnline = async () => {
    if (!tokenRecaptcha && store.enviroment == "production") {
      return notification.alertaApi("Resolva o reCAPTCHA");
    }
    setLoading(true);
    const res = await loginService.logar(
      login,
      store.enviroment == "production" ? tokenRecaptcha : "teste",
    );
    setLoading(false);
    if (!res.isAxiosError) {
      processarDadosUsuario(res.data);
    } else {
      if (res.response && res.response.status == 400) {
        setErro(true);
        notification.alertaApi(res.response.data.message || res.response.data);
        if (
          res.response.data.message ==
          "Este usuário está bloqueado temporariamente"
        ) {
          bloquearUsuario();
        }
      } else {
        responseErros(res);
      }
      window.grecaptcha.reset();
      setTokenRecaptcha(null);
    }
  };

  const onChangeInput = (event) => {
    setLogin((prevState) => ({
      ...prevState,
      [event.target.name]: String(event.target.value).trim(),
    }));
  };

  async function buscarConfiguracoesEmpresa() {
    // if (pdvOnLine) {
    await configuracoesService.get().then((res) => {
      if (!res.isAxiosError) {
        sessionService.setConfiguracoesEmpresa(res.data.rows[0]);
      }
    });
    // } else {
    //   sessionService.setConfiguracoesEmpresaOffline();
    // }
  }

  function bloquearUsuario() {
    setUsuarioBloqueado(true);
    let minutos = 4;
    let segundos = 60;
    const interval = setInterval(() => {
      segundos--;
      if (segundos == 0) {
        if (minutos == 0) {
          setTempoBloqueio("5:00");
          setUsuarioBloqueado(false);
          clearInterval(interval);
          return;
        }
        segundos = 60;
        minutos--;
      }
      const segundosFormatado = segundos < 10 ? `0${segundos}` : segundos;
      setTempoBloqueio(`${minutos}:${segundosFormatado}`);
    }, 1000);
  }

  function onChangeRecaptcha(value) {
    setTokenRecaptcha(value);
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const onClickAbrirDialogoRecuperarSenha = (e) => {
    e.preventDefault();
    setAbrirDialogoRecuperarSenha(true);
  };

  // const onChangePdvOnLine = async (event) => {
  //   if (!dadosOffline || !dadosOffline.configuracoes) {
  //     return notification.alertaGenericos("Modo offline não disponível");
  //   }
  //   if (!event.target.checked) {
  //     UsuariosLocalService.startSincronizacao(dadosOffline.empresaId);
  //   }
  //   sessionService.setPdvOnlineStatus(event.target.checked);
  //   setPdvOnLine(event.target.checked);
  // };

  return (
    <>
      <FloatingBackground />
      {/* {dadosOffline && (
        <div className="switch-offline">
          <FormControlLabel
            control={
              <Switch
                checked={pdvOnLine}
                onChange={onChangePdvOnLine}
                inputProps={{ "aria-label": "controlled" }}
                name="pdvOnLine"
                size="small"
                color="primary"
              />
            }
            label={
              <Typography variant="body2" className="px-1">
                {pdvOnLine ? "Online" : "Offline"}
              </Typography>
            }
          />
        </div>
      )} */}
      <Box
        sx={{
          position: "fixed",
          width: 400,
          height: 400,
          filter: "blur(6rem)",
          top: -100,
          right: -100,
          opacity: 0.08,
          background: palette.primary.main,
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "fixed",
          width: 400,
          height: 400,
          filter: "blur(6rem)",
          bottom: -100,
          left: -100,
          opacity: 0.08,
          background: palette.primary.main,
          zIndex: 0,
        }}
      />
      <main
        className="main-login w-100 d-flex bg-white"
        style={{
          height: "100vh",
        }}
      >
        <Box className="login d-flex w-100 flex-column justify-content-center fw-bold h-100 px-5">
          <Box sx={{ margin: "0 auto" }}>
            <Box className="d-flex">
              <img
                src={logoHorizontal}
                width={"200rem"}
                style={{ marginBottom: "3rem" }}
              />
            </Box>
            {usuarioBloqueado && (
              <span className="text-danger">
                Usuário bloqueado por {tempoBloqueio}
              </span>
            )}
            <form onSubmit={onSubmitLogar} className="mt-2">
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink htmlFor="email">
                  Email
                </InputLabel>
                <TextField
                  variant="standard"
                  name="email"
                  type="text"
                  margin="normal"
                  fullWidth
                  InputProps={{
                    disableUnderline: true,
                  }}
                  sx={sxInputLogin}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(event) => onChangeInput(event)}
                  value={value.text(login.email)}
                  error={inputErros.get("email") || erro ? true : false}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth className="mt-3">
                <InputLabel shrink htmlFor="senha">
                  Senha
                </InputLabel>
                <TextField
                  variant="standard"
                  name="senha"
                  id="senha"
                  margin="normal"
                  fullWidth
                  required
                  sx={sxInputLogin}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  type={showPassword ? "text" : "password"}
                  onChange={(event) => onChangeInput(event)}
                  value={value.text(login.senha)}
                  error={inputErros.get("senha") || erro ? true : false}
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleClickShowPassword}>
                          {showPassword ? (
                            <i
                              className="ph-fill ph-eye"
                              style={{ color: "#494C62", fontSize: 18 }}
                            ></i>
                          ) : (
                            <i
                              className="ph-fill ph-eye-slash"
                              style={{ color: "#494C62", fontSize: 18 }}
                            ></i>
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
              <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
                <a
                  style={{ textDecoration: "none" }}
                  href="#"
                  onClick={(e) => onClickAbrirDialogoRecuperarSenha(e)}
                >
                  Esqueci minha senha
                </a>
              </Typography>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={store.keyRecaptcha}
                onChange={onChangeRecaptcha}
                size="normal"
              />
              <Button
                fullWidth
                variant="contained"
                disabled={usuarioBloqueado}
                size="large"
                type="submit"
                className="mt-3 fw-bold rounded-3"
                sx={{ textTransform: "capitalize" }}
                color={usuarioBloqueado ? "padrao" : "primary"}
                disableElevation
              >
                Entrar
              </Button>
            </form>
          </Box>
        </Box>
        <RecuperarSenhaDialogo
          abrirDialogoRecuperarSenha={abrirDialogoRecuperarSenha}
          setAbrirDialogoRecuperarSenha={setAbrirDialogoRecuperarSenha}
          setLoading={setLoading}
        />
        <DialogoFiliais
          abrirDialogoFiliais={abrirDialogoFiliais}
          setAbrirDialogoFiliais={setAbrirDialogoFiliais}
          dados={dados}
          setLoading={setLoading}
          buscarConfiguracoesEmpresa={buscarConfiguracoesEmpresa}
        />
        <Loading loading={loading} />
      </main>
    </>
  );
};

export default LoginView;
